import { Component, OnInit } from '@angular/core';
import { environment } from './../environments/environment';
import { ReportService } from './services/report.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'vna';
  maintenance: boolean;

  constructor(
    public rs: ReportService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    // Register the custom icon font with MatIconRegistry
    this.matIconRegistry.setDefaultFontSetClass('material-icons');
    
    // Register the 'material-icons' as a named icon set
    this.matIconRegistry.registerFontClassAlias('material-icons');
  }

  ngOnInit() {
    this.maintenance = environment.maintenance;

    // NOTE: Need to check error generated here before activate it back.
    /* this.rs.getTotalFileUsageSizeForClient('b2cxuGqm9XbUNLn0p8NYwgcJ9y03').then((totalSize) => {
      console.log(totalSize);
    }); */
  }
}
